import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm, change, formValueSelector } from "redux-form";
import _ from "lodash";
import moment from "moment";
import { Modal, Row, Col } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import { confirmAlert } from "react-confirm-alert";
import QRCode from "qrcode";
import { jsPDF } from "jspdf";
import {
  openGenerateBadgeModal,
  generateBadges, // print pdf for badges
  blankBadgeUserList,
  sortListUserByCategory, // Fetch user list
  SearchUsersForGenerateBadge,
} from "BadgeDesignAction";
import { fetchUsersCategory } from "DashboardUserAction";
import { showError, showSuccess } from "ReduxErrorBar";
import { BaseComponent, LABEL_POSITION_TOP } from "BaseComponent";
import {
  COMMON_FAIL_MESSAGE,
  ACCESS_FILES_API_KEY,
  BASE_IMAGES_LOCAL_URL,
  BASE_IMAGES_URL,
  INSTANCE_URL,
  IMAGE_PATH,
  validateDecimalNums,
  DISPLAY_LOCAL_DATE_FORMAT,
  MAIN_URL,
} from "Constants";
import {
  centToPixel,
  convertToPixel,
  centToInch,
  inchToCent,
} from "BaseFunctions";
import {
  DEFAULTFONTSIZE,
  DEFAULTFONTFAMILY,
  DEFAULTFONTWEIGHT,
  PAGESIZEOPTIONS,
  PAGEDEFAULTSIZE,
  BADGEDEFAULTSIZE,
} from "../badge-constants";
import GenerateBadgeHeader from "./generate-badge-header";
import GenerateBadgeUsersTable from "./generate-badge-users-table";
import BetaFeature from "BetaFeature";
import LocaleStrings from "Languages";

const badgeForOptions = [
  {
    text: LocaleStrings.dashboard_badgedesign_generate_badge_option1,
    value: "choose_attendees",
    default: true,
  },
  {
    text: LocaleStrings.dashboard_badgedesign_generate_badge_option2,
    value: "specific_category",
    default: false,
  },
  {
    text: LocaleStrings.dashboard_badgedesign_generate_badge_option3,
    value: "all_attendees",
    default: false,
  },
];
const LISTPERPAGE = 0;

class GenerateBadge extends BaseComponent {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      search: "",
      eventLogo: "",
      badgeFor: "choose_attendees",
      selectedCategoryObj: {
        id: "",
        name: "",
      },
      pageNumber: 1,
      selectedUsers: [],
      allCheck: false,
    };

    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    let { session } = this.props;
    let { pageNumber } = this.state;
    /*
        1- Fetch users category
        2- Get user list for first time whatever bydefault selected
    */
    this.props.fetchUsersCategory(session, (response) => {
      this.apiCallForBadgeUsers({
        sort: "all",
        pageNumber: pageNumber,
        perPage: LISTPERPAGE,
      });
    });
  }

  componentWillUnmount() {
    this.reinitializeStatesAndProps();
  }

  // Reintialize states and props
  reinitializeStatesAndProps() {
    // States
    this.setState({
      loading: false,
      search: "",
      eventLogo: "",
      badgeFor: "choose_attendees", //  Generate badge for
      selectedCategoryObj: {
        id: "",
        name: "",
      },
      pageNumber: 1,
      selectedUsers: [],
      allCheck: false,
    });

    // Props
    this.props.reset(); // Reset form
  }

  // Reintialize states for internal update
  reinitializeInternalStates() {
    // States
    this.setState({
      search: "",
      selectedCategoryObj: { id: "", name: "" },
      pageNumber: 1,
      selectedUsers: [],
      allCheck: false,
    });
  }

  closeModal() {
    let { session } = this.props;

    this.props.change("badgefor", "choose_attendees");
    this.props.openGenerateBadgeModal(false);
    /* When closing "Select Attendee & Generate" modal black the current template id*/
    this.props.setStateCurrentTemplateId("");
    this.reinitializeStatesAndProps();

    /*
        1- Fetch users category
        2- Get user list for first time whatever bydefault selected
    */
    this.props.blankBadgeUserList(); // Clear user list
    this.props.fetchUsersCategory(session, (response) => {
      this.apiCallForBadgeUsers({
        sort: "all",
        pageNumber: 1,
        perPage: LISTPERPAGE,
      });
    });
  }

  tagToNameFc = (tagData, userVAl) => {
    let tagName = tagData.name;
    // console.log("tagName :- ", tagName);
    // console.log("userVAl :- ", userVAl);
    var generatedVal = "";
    if (tagName === "#event_name") {
      generatedVal = userVAl.eventname;
    } else if (tagName === "#event_location") {
      generatedVal = userVAl.country;
    } else if (tagName === "#full_name") {
      generatedVal = userVAl.username;
    } else if (tagName === "#first_name") {
      generatedVal = userVAl.firstname;
    } else if (tagName === "#last_name") {
      generatedVal = userVAl.lastname;
    } else if (tagName === "#company_name") {
      let jsonData = JSON.parse(userVAl.responses);
      let match = _.filter(jsonData, (obj) => {
        return obj.name === "company";
      });
      let company = match.length > 0 && match[0].value ? match[0].value : "";

      generatedVal = company;
    } else if (tagName === "#designation") {
      let jsonData = JSON.parse(userVAl.responses);
      let match = _.filter(jsonData, (obj) => {
        return obj.name === "designation";
      });
      let designation =
        match.length > 0 && match[0].value ? match[0].value : "";

      generatedVal = designation;
    } else if (tagName === "#registration_type") {
      let regType =
        userVAl.comesfrom === "admin_panel"
          ? "Admin"
          : userVAl.comesfrom === "ticket"
          ? "Ticket"
          : userVAl.comesfrom === "api"
          ? "Api"
          : userVAl.comesfrom === "open_registration"
          ? "Open Registration"
          : userVAl.comesfrom === "proposal"
          ? "Abstract"
          : "N/A";

      generatedVal = regType;
    } else if (tagName === "#primary_group") {
      let associated = _.split(userVAl.usercategory_name, ",");

      generatedVal = associated.length > 0 ? associated[0] : "-";
    } else {
      if (
        tagData.iscustom === true &&
        tagData.htmlType === "input" &&
        tagData.textValue
      ) {
        if (
          tagData.textValue.indexOf("{{") > -1 &&
          tagData.textValue.indexOf("}}") > -1
        ) {
          let rep = tagData.textValue.replace(/[{}]/g, "").trim();
          // console.log("rep :- ", rep);
          let jsonData = JSON.parse(userVAl.responses);
          // console.log("jsonData :- ", jsonData);
          let match = _.filter(jsonData, (obj) => {
            return obj.name == rep;
          });
          // console.log("match :- ", match);
          let customVal = "";

          if (match.length > 0) {
            let key = match[0].key;
            if (key !== "hyperlink" && key !== "label" && key !== "paragraph") {
              let value = match[0].value ? match[0].value : "";
              // console.log("value :-", value);
              if (key === "checkboxes" && Array.isArray(value)) {
                let options = match[0].options;
                let matchedVal = [];

                value.forEach((element) => {
                  let m = _.filter(options, (o) => {
                    return o.text === element || o.value === element;
                  });
                  if (m.length > 0) {
                    matchedVal.push(m[0].text);
                  }
                });

                customVal = matchedVal.join(", ");
              } else if (
                (key === "dropdown" || key === "radiobuttons") &&
                value !== ""
              ) {
                let options = match[0].options;

                let m = _.filter(options, (o) => {
                  return o.text === value || o.value === value;
                });
                if (m.length > 0) {
                  customVal = m[0].text;
                }
              } else if (key === "datepicker" && value !== "") {
                customVal = moment(value).format(DISPLAY_LOCAL_DATE_FORMAT);
              } else {
                customVal = value;
              }
            }
          }

          generatedVal = customVal;
        } else {
          generatedVal = tagData.textValue;
        }
      } else {
        generatedVal = tagName;
      }
    }

    return generatedVal;
  };

  /* Download pdf */
  download_file = (response) => {
    let fileName = response.filename;
    let fileURL = response.successS3
      ? BASE_IMAGES_URL + fileName + "?api_key=" + ACCESS_FILES_API_KEY
      : BASE_IMAGES_LOCAL_URL + fileName + "?api_key=" + ACCESS_FILES_API_KEY;

    // for non-IE
    if (!window.ActiveXObject) {
      var save = document.createElement("a");
      save.href = fileURL;
      save.target = "_blank";
      var filename = fileURL.substring(fileURL.lastIndexOf("/") + 1);
      save.download = fileName || filename;
      if (
        navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) &&
        navigator.userAgent.search("Chrome") < 0
      ) {
        document.location = save.href;
        // window event not working here
      } else {
        var evt = new MouseEvent("click", {
          view: window,
          bubbles: true,
          cancelable: false,
        });
        save.dispatchEvent(evt);
        (window.URL || window.webkitURL).revokeObjectURL(save.href);
      }
    } else if (!!window.ActiveXObject && document.execCommand) {
      var _window = window.open(fileURL, "_blank");
      _window.document.close();
      _window.document.execCommand("SaveAs", true, fileName || fileURL);
      _window.close();
    }
  };

  demoFromHTML = (response) => {
    let fileName = response.htmlname;

    let fileURL = response.successS3
      ? BASE_IMAGES_URL + fileName + "?api_key=" + ACCESS_FILES_API_KEY
      : BASE_IMAGES_LOCAL_URL + fileName + "?api_key=" + ACCESS_FILES_API_KEY;

    window.open(fileURL);
  };

  // Generating badge from serverside (not in use)
  onFormSubmit_old(values) {
    let { session, userList, currentTemplateId } = this.props;
    let { selectedUsers } = this.state;
    let totalNumberOfUsers = 0;
    // console.log("selectedUsers - ", selectedUsers);

    /* Validation */
    if (values.badgefor === "specific_category") {
      if (!_.has(values, "category")) {
        this.props.showError(
          LocaleStrings.generate_badge_for_select_category_validation
        );
        return false;
      } else if (_.has(values, "category") && _.size(values.category) === 0) {
        this.props.showError(
          LocaleStrings.generate_badge_for_select_category_validation
        );
        return false;
      } else {
        // code
      }
    } else if (
      values.badgefor === "choose_attendees" &&
      _.size(selectedUsers) === 0
    ) {
      /* error - Not enough record to print
        As in case of choose_attendees selectedUsers will work as usersInArr -> we will print which are in this only
      */
      this.props.showError(LocaleStrings.no_data_found);
      return false;
    } else {
      // #
    }

    /* 
      Total number of users will be 
      total user list count - excluding users (uncheck users)
    */

    if (values.badgefor === "choose_attendees") {
      // As in case of choose_attendees selectedUsers will work as usersInArr -> we will print which are in this only
      totalNumberOfUsers = _.size(selectedUsers);
    } else {
      totalNumberOfUsers =
        userList && userList.count ? userList.count - _.size(selectedUsers) : 0;
    }

    if (totalNumberOfUsers === 0) {
      /* error - Not enough record to print */
      this.props.showError(LocaleStrings.no_data_found);
      return false;
    }

    confirmAlert({
      title: LocaleStrings.dashboard_badgedesign_generate_badge_title,
      message: _.replace(
        LocaleStrings.dashboard_badgedesign_generate_badge_message,
        "#",
        totalNumberOfUsers
      ),
      confirmLabel: LocaleStrings.button_ok,
      cancelLabel: LocaleStrings.button_cancel,
      buttons: [
        {
          label: LocaleStrings.button_ok,
          onClick: () => {
            this.setState({ loading: true });

            let dataObject = {
              templateid: parseInt(currentTemplateId), // Badge templte id
              badgefor: values.badgefor,
              categoryid: "", // appuser_groups -> id
              categoryname: "",
              pdfsettings: false,
              usersnotin:
                _.size(selectedUsers) > 0
                  ? _.toString(selectedUsers.map((user) => user.appuserid))
                  : "",
              requesttype: "generateBadgePdf",
              // requesttype: "generateBadgePdfFrontEnd",
            }; // Initialize blank object to send as params

            if (_.has(values, "category")) {
              let dataArray = _.split(values.category, "#");
              dataObject.categoryname = dataArray[0];
              dataObject.categoryid = parseInt(dataArray[1]);
              // If category exist Means "Generate badge for" = 'Specific category'
            }

            if (_.has(values, "pdfsettings")) {
              dataObject.pdfsettings = true;
            }

            /* API call Generate badge pdf to create pdf  */
            this.props.generateBadges(session, dataObject, (callback) => {
              if (callback.success === 0) {
                this.props.showError(COMMON_FAIL_MESSAGE);
                this.setState({ loading: false });
              } else {
                //this.download_file(callback);

                this.demoFromHTML(callback);
                this.setState({ loading: false });
              }
            });
          },
        },
        {
          label: LocaleStrings.button_cancel,
          onClick: () => {},
        },
      ],
    });
  }

  // Generating multiple badge locally (not in use)
  onFormSubmit_1badge1page(values) {
    // console.log("values :- ", values);
    let { currentTemplateId, badgeList, allUserList, eventDetails } =
      this.props;
    var selectedUsers = this.state.selectedUsers;
    // console.log("allUserList :- ", allUserList);

    if (values.badgefor === "all_attendees") {
      selectedUsers = allUserList.data ? allUserList.data : [];
    } else if (values.badgefor === "specific_category") {
      var allusers = allUserList.data ? allUserList.data : [];
      var selCat = _.split(values.category, "#").pop();
      // console.log("selCat :- ", selCat);

      var matchedCat = _.filter(allusers, (o) => {
        return o.usercategory.indexOf(selCat) >= 0;
      });
      // console.log("matchedCat :- ", matchedCat);

      selectedUsers = matchedCat;
    }

    let totalNumberOfUsers = selectedUsers.length;
    // console.log("currentTemplateId - ", currentTemplateId);
    // console.log("selectedUsers - ", selectedUsers);

    if (
      (values.badgefor === "all_attendees" ||
        values.badgefor === "specific_category") &&
      _.isEmpty(allUserList)
    ) {
      /* error - Not enough record to print */
      this.props.showError(
        LocaleStrings.dashboard_badgedesign_generate_wait_message
      );
      return false;
    }

    if (totalNumberOfUsers === 0) {
      /* error - Not enough record to print */
      this.props.showError(LocaleStrings.no_data_found);
      return false;
    }

    var selcted = _.filter(badgeList.data, (obj) => {
      return obj.badgeid == currentTemplateId;
    });
    var selctedBadge = selcted[0];
    // console.log("selctedBadge - ", selctedBadge);

    var pageSize = selctedBadge.page_size;
    var pagePadding = selctedBadge.page_padding;
    var badgeSize = selctedBadge.badge_size;
    var templateData = JSON.parse(selctedBadge.template); // String to json parse for template
    templateData.reverse(); // Only for z-index, as last element in array will be in last indexing;

    // Get page size (W * H)
    var pageSizeArray = _.split(pageSize, "#");
    var pageWidth = centToPixel(pageSizeArray[0]).toFixed(2);
    var pageHeight = centToPixel(pageSizeArray[1]).toFixed(2);

    // Get page padding (T R B L)
    var pagePaddingArray = _.split(pagePadding, "#");
    var pagePaddingTop = pagePaddingArray[0]
      ? centToPixel(pagePaddingArray[0])
      : 0;
    var pagePaddingLeft = pagePaddingArray[3]
      ? centToPixel(pagePaddingArray[3])
      : 0;

    // Get badhe size (W * H)
    var badgeSizeArray = _.split(badgeSize, "#");
    var boxWidth = centToPixel(badgeSizeArray[0]);
    var boxHeight = centToPixel(badgeSizeArray[1]);
    var event_log_src = `${BASE_IMAGES_URL}/${eventDetails.eventicon}?api_key=${ACCESS_FILES_API_KEY}`;

    // fetching event logo once and using for all badges.
    let imageURL;
    fetch(event_log_src)
      .then((res) => res.blob())
      .then((blob) => {
        imageURL = window.URL.createObjectURL(blob);

        this.setState({ eventLogo: imageURL });
      });

    // fetching template custom images once and using for all badges.
    var customImageArr = [];
    var promiseCImgArray = [];
    _.forEach(templateData, (template) => {
      promiseCImgArray.push(
        new Promise(async (resolve, reject) => {
          if (
            !template.hidden &&
            template.iscustom &&
            template.htmlType === "image"
          ) {
            let cimage = `${BASE_IMAGES_URL}/${template.imageValue}?api_key=${ACCESS_FILES_API_KEY}`;
            let imgUrl;
            fetch(cimage)
              .then((res) => res.blob())
              .then((blob) => {
                imgUrl = window.URL.createObjectURL(blob);

                let obj = { id: template.id, image: imgUrl };

                customImageArr.push(obj);
                resolve();
              });
          } else {
            resolve();
          }
        })
      );
    });

    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="react-confirm-alert-body">
            <h1>{LocaleStrings.dashboard_badgedesign_generate_badge_title}</h1>
            <p>
              {_.replace(
                LocaleStrings.dashboard_badgedesign_generate_badge_message,
                "#",
                totalNumberOfUsers
              )}
            </p>

            <div className="react-confirm-alert-button-group">
              <button
                type="button"
                onClick={() => {
                  onClose();
                  this.setState({ loading: true });
                  var orientation = "p";
                  if (pageWidth > pageHeight) {
                    orientation = "l";
                  }
                  const doc = new jsPDF(orientation, "pt", [
                    pageWidth,
                    pageHeight,
                  ]);

                  var allqrDataArr = [];
                  var promiseArray = [];
                  _.forEach(selectedUsers, (user, index) => {
                    promiseArray.push(
                      new Promise(async (resolve, reject) => {
                        var magicurlqr = user.userqrstring;
                        var qrdata = await QRCode.toDataURL(magicurlqr, {
                          margin: 0,
                        });
                        allqrDataArr.push(qrdata);
                        resolve();
                      })
                    );
                  });

                  var arrMerge = promiseCImgArray.concat(promiseArray);
                  // console.log("arrMerge :- ", arrMerge);

                  Promise.all(arrMerge).then(() => {
                    // console.log("allqrDataArr", allqrDataArr);
                    // console.log("customImageArr :- ", customImageArr);

                    _.forEach(selectedUsers, (user, index) => {
                      user.eventname = eventDetails.eventname;
                      user.eventicon = eventDetails.eventicon;
                      user.country = eventDetails.country;
                      var eventlogowidth = 50;
                      var eventlogohight = 50;
                      var qrwidth = 50;
                      var qrhight = 50;
                      var customimagewidth = boxWidth;
                      var customimagehight = boxHeight;
                      var mylink = allqrDataArr[index];

                      _.forEach(templateData, (template) => {
                        // console.log("template :- ", template);
                        var fontsize = DEFAULTFONTSIZE.replace(/\D/g, "");
                        var fontweight = DEFAULTFONTWEIGHT;
                        var fontfamily = DEFAULTFONTFAMILY;
                        var fontstyle = "";
                        var textdecoration = "";
                        var texttransform = "none";
                        var textcolor = "#000000";

                        var templateX =
                          template.x != 0 ? template.x / 2 : template.x;
                        var templateY =
                          template.y != 0 ? template.y / 2 : template.y;

                        // Only show those which hidden key value is 'false' in json
                        if (template.hidden == false) {
                          var ismiddle = 0; // -> JS PART

                          // Check the style set for current field
                          _.forEach(template.style, (stylevalue, styleKey) => {
                            if (
                              stylevalue != null &&
                              stylevalue != "null" &&
                              stylevalue != "" &&
                              styleKey !== "border"
                            ) {
                              if (
                                template.htmlType == "div" ||
                                template.htmlType == "input"
                              ) {
                                if (styleKey === "fontSize") {
                                  var stVal = stylevalue.replace(/\D/g, ""); // replace pxfrom style value to divide by 2
                                  fontsize = stVal / 2;
                                } else {
                                  var stVal = stylevalue;
                                }

                                if (styleKey === "fontWeight") {
                                  fontweight = stVal;
                                }
                                if (styleKey === "fontFamily") {
                                  fontfamily = stVal;
                                }
                                if (styleKey === "fontStyle") {
                                  fontstyle = stVal;
                                }
                                if (styleKey === "textDecoration") {
                                  textdecoration = stVal;
                                }
                                if (styleKey === "color") {
                                  textcolor = stVal;
                                }
                                if (
                                  styleKey === "textAlign" &&
                                  stylevalue === "center"
                                ) {
                                  templateX = 0;
                                  ismiddle = 1; // -> JS PART
                                }
                              } else {
                                if (
                                  styleKey === "width" ||
                                  styleKey === "height"
                                ) {
                                  var stVal = stylevalue / 2;

                                  if (styleKey === "width") {
                                    if (template.name === "#qr_code") {
                                      qrwidth = stVal;
                                    }
                                    if (template.name === "#event_logo") {
                                      eventlogowidth = stVal;
                                    }
                                    if (
                                      template.iscustom &&
                                      template.htmlType === "image"
                                    ) {
                                      customimagewidth = stVal;
                                    }
                                  }

                                  if (styleKey === "height") {
                                    if (template.name === "#qr_code") {
                                      qrhight = stVal;
                                    }
                                    if (template.name === "#event_logo") {
                                      eventlogohight = stVal;
                                    }
                                    if (
                                      template.iscustom &&
                                      template.htmlType === "image"
                                    ) {
                                      customimagehight = stVal;
                                    }
                                  }
                                } else {
                                  var stVal = stylevalue;
                                }
                              }
                            }
                          });

                          // FOR EVENT LOG
                          if (template.name === "#event_logo") {
                            // var event_log_src = `${BASE_IMAGES_URL}/${user.eventicon}?api_key=${ACCESS_FILES_API_KEY}`;
                            var event_log_src = this.state.eventLogo;
                            var imgData = event_log_src;

                            if (eventlogowidth > eventlogohight) {
                              doc.addImage(
                                imgData,
                                "JPEG",
                                templateX,
                                templateY,
                                eventlogowidth,
                                eventlogohight
                              );
                            } else {
                              doc.addImage(
                                imgData,
                                "JPEG",
                                templateX,
                                templateY,
                                eventlogohight,
                                eventlogowidth
                              );
                            }
                          } else if (
                            template.iscustom &&
                            template.htmlType === "image"
                          ) {
                            var match = _.filter(customImageArr, (o) => {
                              return o.id === template.id;
                            });
                            var customimage =
                              match.length > 0
                                ? match[0].image
                                : `${BASE_IMAGES_URL}/${template.imageValue}?api_key=${ACCESS_FILES_API_KEY}`;
                            var imgData = customimage;

                            if (customimagewidth > customimagehight) {
                              doc.addImage(
                                imgData,
                                "JPEG",
                                templateX,
                                templateY,
                                customimagewidth,
                                customimagehight
                              );
                            } else {
                              doc.addImage(
                                imgData,
                                "JPEG",
                                templateX,
                                templateY,
                                customimagehight,
                                customimagewidth
                              );
                            }
                          } else if (template.name === "#qr_code") {
                            var magicurlqr = user.userqrstring;
                            // var mylink = `${INSTANCE_URL}/qrcode.php?s=qr&d=${magicurlqr}&sf=10&ms=r&md=1&wq=0&h=500&w=500`;
                            var imgData = mylink;
                            // console.log("imgData :- ", imgData);

                            doc.addImage(
                              imgData,
                              "JPEG",
                              templateX,
                              templateY,
                              qrhight,
                              qrwidth
                            );
                          } else if (template.htmlType === "input") {
                            // For any input type

                            doc.setFontSize(fontsize);
                            doc.setFont(
                              `${fontfamily}`,
                              `${fontstyle}`,
                              `${fontweight}`
                            );
                            doc.setTextColor(`${textcolor}`);

                            if (ismiddle == 1) {
                              var getPageWidth =
                                doc.internal.pageSize.width ||
                                doc.internal.pageSize.getWidth();
                              doc.text(
                                `${template.textValue}`,
                                getPageWidth / 2,
                                templateY + fontsize,
                                { align: "center", maxWidth: getPageWidth }
                              );
                            } else {
                              doc.text(
                                `${template.textValue}`,
                                templateX,
                                templateY + fontsize
                              );
                            }
                          } else {
                            doc.setFontSize(fontsize);
                            doc.setFont(
                              `${fontfamily}`,
                              `${fontstyle}`,
                              `${fontweight}`
                            );
                            doc.setTextColor(`${textcolor}`);

                            if (ismiddle == 1) {
                              var getPageWidth =
                                doc.internal.pageSize.width ||
                                doc.internal.pageSize.getWidth();
                              doc.text(
                                `${this.tagToNameFc(template, user)}`,
                                getPageWidth / 2,
                                templateY + fontsize,
                                { align: "center", maxWidth: getPageWidth }
                              );
                            } else {
                              doc.text(
                                `${this.tagToNameFc(template, user)}`,
                                templateX,
                                templateY + fontsize
                              );
                            }
                          }
                        }
                      });
                      if (selectedUsers.length - 1 > index) {
                        doc.addPage([pageWidth, pageHeight], orientation);
                      }
                    });

                    this.setState({ loading: false });
                    if (values.badgefor === "choose_attendees") {
                      this.setState({ selectedUsers: [], allCheck: false });
                    }

                    doc.save("usersbadges.pdf");
                  });
                }}
              >
                {LocaleStrings.button_ok}
              </button>
              <button onClick={onClose}>{LocaleStrings.button_cancel}</button>
            </div>
          </div>
        );
      },
    });
  }

  // Generating multiple badge locally
  async onFormSubmit(values) {
    // console.log("values :- ", values);
    let { currentTemplateId, badgeList, allUserList, eventDetails } =
      this.props;
    var selectedUsers = this.state.selectedUsers;
    // console.log("allUserList :- ", allUserList);

    if (values.badgefor === "all_attendees") {
      selectedUsers = allUserList.data ? allUserList.data : [];
    } else if (values.badgefor === "specific_category") {
      var allusers = allUserList.data ? allUserList.data : [];
      var selCat = _.split(values.category, "#").pop();
      // console.log("selCat :- ", selCat);

      var matchedCat = _.filter(allusers, (o) => {
        return o.usercategory.indexOf(selCat) >= 0;
      });
      // console.log("matchedCat :- ", matchedCat);

      selectedUsers = matchedCat;
    }

    let totalNumberOfUsers = selectedUsers.length;
    // console.log("currentTemplateId - ", currentTemplateId);
    // console.log("selectedUsers - ", selectedUsers);

    if (
      (values.badgefor === "all_attendees" ||
        values.badgefor === "specific_category") &&
      _.isEmpty(allUserList)
    ) {
      /* error - Not enough record to print */
      this.props.showError(
        LocaleStrings.dashboard_badgedesign_generate_wait_message
      );
      return false;
    }

    if (totalNumberOfUsers === 0) {
      /* error - Not enough record to print */
      this.props.showError(LocaleStrings.no_data_found);
      return false;
    }

    var selcted = _.filter(badgeList.data, (obj) => {
      return obj.badgeid == currentTemplateId;
    });
    var selctedBadge = selcted[0];
    // console.log("selctedBadge - ", selctedBadge);

    var badgeSize = selctedBadge.badge_size;
    var templateData = JSON.parse(selctedBadge.template); // String to json parse for template
    templateData.reverse(); // Only for z-index, as last element in array will be in last indexing;

    // Get badhe size (W * H)
    var badgeSizeArray = _.split(badgeSize, "#");
    // var boxWidth = parseFloat(centToPixel(badgeSizeArray[0]));
    // var boxHeight = parseFloat(centToPixel(badgeSizeArray[1]));

    var boxWidth = parseFloat(
      convertToPixel(selctedBadge.measurement, badgeSizeArray[0])
    );
    var boxHeight = parseFloat(
      convertToPixel(selctedBadge.measurement, badgeSizeArray[1])
    );

    // console.log("boxWidth :- ", boxWidth);
    // console.log("boxHeight :- ", boxHeight);

    var printType = values.printtype;
    var pageWidth = boxWidth;
    var pageHeight = boxHeight;
    var pagePaddingTop = 0;
    var pagePaddingLeft = 0;
    var columnSpacing = 0;
    var rowSpacing = 0;
    var columnInRow = 1;
    var rowsInPage = 1;
    if (printType === "multiple") {
      // Get page size (W * H)
      var pageSize = values.page_size;
      var calculationType = values.calculatein;
      if (pageSize === "custom") {
        pageWidth = parseFloat(
          convertToPixel(
            calculationType,
            values.pagewidth && values.pagewidth < 0 ? 0 : values.pagewidth
          ).toFixed(2)
        );
        pageHeight = parseFloat(
          convertToPixel(
            calculationType,
            values.pageheight && values.pageheight < 0 ? 0 : values.pageheight
          ).toFixed(2)
        );
      } else {
        let pageSizeArray = _.split(pageSize, "#");
        pageWidth = parseFloat(centToPixel(pageSizeArray[0]).toFixed(2));
        pageHeight = parseFloat(centToPixel(pageSizeArray[1]).toFixed(2));
      }

      // console.log("Original pageWidth :- ", pageWidth);
      // console.log("Original pageHeight :- ", pageHeight);

      // Get the page padding (T R B L)
      pagePaddingTop = parseFloat(
        convertToPixel(
          calculationType,
          values.page_padding_top && values.page_padding_top < 0
            ? 0
            : values.page_padding_top
        ).toFixed(2)
      );
      pagePaddingLeft = parseFloat(
        convertToPixel(
          calculationType,
          values.page_padding_left && values.page_padding_left < 0
            ? 0
            : values.page_padding_left
        ).toFixed(2)
      );

      // console.log("pagePaddingTop :- ", pagePaddingTop);
      // console.log("pagePaddingLeft :- ", pagePaddingLeft);

      // Reduce the page padding from page size
      var finalPageWidth = (pageWidth - pagePaddingLeft).toFixed(2);
      var finalPageHeight = (pageHeight - pagePaddingTop).toFixed(2);
      // console.log("Padding Reduce pageWidth :- ", finalPageWidth);
      // console.log("Padding Reduce pageHeight :- ", finalPageHeight);

      // Get the badges in each row and rows in each page befor col & row spacing
      columnInRow = Math.floor(finalPageWidth / boxWidth);
      rowsInPage = Math.floor(finalPageHeight / boxHeight);

      // console.log("Before column spacing columnInRow :- ", columnInRow);
      // console.log("Before row spacing rowsInPage :- ", rowsInPage);

      // Get the column & row spacing
      columnSpacing = parseFloat(
        convertToPixel(
          calculationType,
          values.column_spacing && values.column_spacing < 0
            ? 0
            : values.column_spacing
        ).toFixed(2)
      );
      rowSpacing = parseFloat(
        convertToPixel(
          calculationType,
          values.row_spacing && values.row_spacing < 0 ? 0 : values.row_spacing
        ).toFixed(2)
      );

      // console.log("columnSpacing :- ", columnSpacing);
      // console.log("rowSpacing :- ", rowSpacing);

      // Get total column & row spacing. Here -1 is because row and column space is added between 2 badge only 1 time.
      var pageColumnSpacing = parseFloat(
        (columnSpacing * (columnInRow - 1)).toFixed(2)
      );
      var pageRowSpacing = parseFloat(
        (rowSpacing * (rowsInPage - 1)).toFixed(2)
      );

      // console.log("pageColumnSpacing :- ", pageColumnSpacing);
      // console.log("pageRowSpacing :- ", pageRowSpacing);

      // reduce the column & row spacing
      finalPageWidth = parseFloat(
        (finalPageWidth - pageColumnSpacing).toFixed(2)
      );
      finalPageHeight = parseFloat(
        (finalPageHeight - pageRowSpacing).toFixed(2)
      );

      // console.log("Column spacing Reduce pageWidth :- ", finalPageWidth);
      // console.log("Row spacing  Reduce pageHeight :- ", finalPageHeight);

      // Get the final column in each row and row in each page
      columnInRow = Math.floor(finalPageWidth / boxWidth);
      rowsInPage = Math.floor(finalPageHeight / boxHeight);

      // console.log("columnInRow :- ", columnInRow);
      // console.log("rowsInPage :- ", rowsInPage);
      // console.log("====================================");
    }

    this.setState({ loading: true });
    // Check if event logo required in template or not
    let matchEventLogo = _.filter(templateData, (o) => {
      return o.id === "event_logo" && !o.hidden;
    });
    var eventLogo = "";
    if (matchEventLogo.length > 0) {
      // fetching event logo once and using for all badges.
      var event_log_src = `${BASE_IMAGES_URL}/${eventDetails.eventicon}?api_key=${ACCESS_FILES_API_KEY}`;
      var promiseEventLogoArray = [];
      promiseEventLogoArray.push(
        new Promise(async (resolve, reject) => {
          fetch(event_log_src)
            .then((res) => res.blob())
            .then((blob) => {
              eventLogo = window.URL.createObjectURL(blob);
              resolve();
            });
        })
      );
    }

    // fetching template custom images once and using for all badges.
    var customImageArr = [];
    var promiseCImgArray = [];
    _.forEach(templateData, (template) => {
      promiseCImgArray.push(
        new Promise(async (resolve, reject) => {
          if (
            !template.hidden &&
            template.iscustom &&
            template.htmlType === "image"
          ) {
            let cimage = `${BASE_IMAGES_URL}/${template.imageValue}?api_key=${ACCESS_FILES_API_KEY}`;
            let imgUrl;
            fetch(cimage)
              .then((res) => res.blob())
              .then((blob) => {
                imgUrl = window.URL.createObjectURL(blob);

                let obj = { id: template.id, image: imgUrl };

                customImageArr.push(obj);
                resolve();
              });
          } else {
            resolve();
          }
        })
      );
    });

    var orientation = "p";
    if (pageWidth > pageHeight) {
      orientation = "l";
    }

    const doc = new jsPDF(orientation, "pt", [pageWidth, pageHeight]);

    var allqrDataArr = [];
    var promiseArray = [];
    _.forEach(selectedUsers, (user, index) => {
      promiseArray.push(
        new Promise(async (resolve, reject) => {
          var magicurlqr = user.userqrstring;
          var qrdata = await QRCode.toDataURL(magicurlqr, {
            margin: 0,
          });
          allqrDataArr.push(qrdata);
          resolve();
        })
      );
    });

    var arrMerge = promiseCImgArray.concat(promiseArray, promiseEventLogoArray);
    // console.log("arrMerge :- ", arrMerge);

    let fileImported = [];
    Promise.all(arrMerge).then(() => {
      // console.log("allqrDataArr", allqrDataArr);
      // console.log("customImageArr :- ", customImageArr);
      // console.log("eventLogo :- ", eventLogo);

      var pageRowNumber = 1; // Used for Row no. count for each page
      var columnCount = 1; // Used for column no. of each row
      var multiplyX = 0; // Used to calculate the each badge x position. With this we multiple the the boxwidth to get x position of each badge
      var multiplyY = 0; // Used to calculate the each badge y position. With this we multiple the the boxheight to get y position of each badge

      _.forEach(selectedUsers, (user, index) => {
        user.eventname = eventDetails.eventname;
        user.eventicon = eventDetails.eventicon;
        user.country = eventDetails.country;
        var eventlogowidth = 50;
        var eventlogohight = 50;
        var qrwidth = 50;
        var qrhight = 50;
        var customimagewidth = boxWidth;
        var customimagehight = boxHeight;
        var mylink = allqrDataArr[index];

        // console.log("pageRowNumber : -", pageRowNumber);
        // console.log("columnCount : -", columnCount);

        _.forEach(templateData, (template) => {
          // console.log("template :- ", template);
          var fontsize = DEFAULTFONTSIZE.replace(/\D/g, "");
          var fontweight = DEFAULTFONTWEIGHT;
          var fontfamily = DEFAULTFONTFAMILY;
          var fontstyle = "";
          var textdecoration = "";
          var texttransform = "none";
          var textcolor = "#000000";

          // Template particular element actual x, y position
          var templateX = template.x / 2;
          var templateY = template.y / 2;

          // Calcualte and get the each badge x, y position.
          templateX = parseFloat((templateX + boxWidth * multiplyX).toFixed(2));
          templateY = parseFloat(
            (templateY + boxHeight * multiplyY).toFixed(2)
          );

          // Add the page padding left with each row's first column
          if (columnCount === 1) {
            templateX = templateX + pagePaddingLeft;
          }
          // Add the page padding top with each page's first row
          if (pageRowNumber === 1) {
            templateY = templateY + pagePaddingTop;
          }
          // console.log("templateX PL :- ", templateX);
          // console.log("templateY PT :- ", templateY);

          // Add column space with each badge after 1st column of each row
          if (columnCount > 1) {
            templateX =
              templateX + pagePaddingLeft + columnSpacing * (columnCount - 1);
          }
          // Add row space with each row after 1st row of each page
          if (pageRowNumber > 1) {
            templateY =
              templateY + pagePaddingTop + rowSpacing * (pageRowNumber - 1);
          }
          // console.log("templateX CS :- ", templateX);
          // console.log("templateY RS :- ", templateY);

          // Only show those which hidden key value is 'false' in json
          if (!template.hidden) {
            var ismiddle = 0;
            // console.log("-----------start--------------------");

            // Check the style set for current field
            var stVal = "";
            _.forEach(template.style, (stylevalue, styleKey) => {
              if (
                stylevalue !== null &&
                stylevalue !== "null" &&
                stylevalue !== "" &&
                styleKey !== "border"
              ) {
                if (
                  template.htmlType == "div" ||
                  template.htmlType == "input"
                ) {
                  if (styleKey === "fontSize") {
                    stVal = stylevalue.replace(/\D/g, ""); // replace pxfrom style value to divide by 2
                    fontsize = stVal / 2;
                  } else {
                    stVal = stylevalue;
                  }

                  if (styleKey === "fontWeight") {
                    fontweight = stVal;
                  }
                  if (styleKey === "fontFamily") {
                    fontfamily = stVal;
                  }
                  if (styleKey === "fontStyle") {
                    fontstyle = stVal;
                  }
                  if (styleKey === "textDecoration") {
                    textdecoration = stVal;
                  }
                  if (styleKey === "textTransform") {
                    texttransform = stVal;
                  }
                  if (styleKey === "color") {
                    textcolor = stVal;
                  }
                  if (styleKey === "textAlign" && stylevalue === "center") {
                    let eachBoxWidth = boxWidth * multiplyX;
                    let getBoxWidth = boxWidth / 2;
                    templateX =
                      eachBoxWidth +
                      getBoxWidth +
                      pagePaddingLeft +
                      columnSpacing * (columnCount - 1);
                    ismiddle = 1;
                  }
                } else {
                  if (styleKey === "width" || styleKey === "height") {
                    stVal = stylevalue / 2;

                    if (styleKey === "width") {
                      if (template.name === "#qr_code") {
                        qrwidth = stVal;
                      }
                      if (template.name === "#event_logo") {
                        eventlogowidth = stVal;
                      }
                      if (template.iscustom && template.htmlType === "image") {
                        customimagewidth = stVal;
                      }
                    }

                    if (styleKey === "height") {
                      if (template.name === "#qr_code") {
                        qrhight = stVal;
                      }
                      if (template.name === "#event_logo") {
                        eventlogohight = stVal;
                      }
                      if (template.iscustom && template.htmlType === "image") {
                        customimagehight = stVal;
                      }
                    }
                  } else {
                    stVal = stylevalue;
                  }
                }
              }
            });

            // FOR EVENT LOG
            if (template.name === "#event_logo") {
              // let event_log_src = `${BASE_IMAGES_URL}/${user.eventicon}?api_key=${ACCESS_FILES_API_KEY}`;
              let event_log_src = eventLogo;
              let imgData = event_log_src;

              doc.addImage(
                imgData,
                "JPEG",
                templateX,
                templateY,
                eventlogowidth,
                eventlogohight
              );
            } else if (template.iscustom && template.htmlType === "image") {
              let match = _.filter(customImageArr, (o) => {
                return o.id === template.id;
              });
              let customimage =
                match.length > 0
                  ? match[0].image
                  : `${BASE_IMAGES_URL}/${template.imageValue}?api_key=${ACCESS_FILES_API_KEY}`;
              let imgData = customimage;

              doc.addImage(
                imgData,
                "JPEG",
                templateX,
                templateY,
                customimagewidth,
                customimagehight
              );
            } else if (template.name === "#qr_code") {
              // let magicurlqr = user.userqrstring;
              // let mylink = `${INSTANCE_URL}/qrcode.php?s=qr&d=${magicurlqr}&sf=10&ms=r&md=1&wq=0&h=500&w=500`;
              let imgData = mylink;
              // console.log("imgData :- ", imgData);

              doc.addImage(
                imgData,
                "JPEG",
                templateX,
                templateY,
                qrwidth,
                qrhight
              );
            } else if (template.htmlType === "input") {
              // For any input type
              let getVal = this.tagToNameFc(template, user);
              let textVal =
                texttransform == "uppercase" ? getVal.toUpperCase() : getVal;
              // let textVal =
              //   texttransform == "uppercase"
              //     ? template.textValue.toUpperCase()
              //     : template.textValue;

              if (fontfamily == "Helvetica") {
                doc.setFont(`${fontfamily}`, `${fontstyle}`, `${fontweight}`);
              } else {
                let fontFile = "Normal";
                if (fontweight === "bold") {
                  fontFile = "Bold";
                }
                if (fontstyle === "italic") {
                  fontFile = `${fontFile}Italic`;
                }

                let fontFileName = `${fontfamily}-${fontFile}`;
                if (!_.includes(fileImported, fontFileName)) {
                  fileImported.push(fontFileName);
                  let importFont = `${MAIN_URL}/assets/fonts/${fontFileName}.ttf`;
                  doc.addFont(`${importFont}`, `${fontfamily}`, "normal");
                }
                doc.setFont(`${fontfamily}`);
              }
              doc.setFontSize(fontsize);
              doc.setTextColor(`${textcolor}`);

              if (ismiddle == 1) {
                doc.text(`${textVal}`, templateX, templateY + fontsize, {
                  align: "center",
                  maxWidth: boxWidth,
                });
              } else {
                doc.text(`${textVal}`, templateX, templateY + fontsize);
              }
            } else {
              let getVal = this.tagToNameFc(template, user);
              let textVal =
                texttransform == "uppercase" ? getVal.toUpperCase() : getVal;

              if (fontfamily == "Helvetica") {
                doc.setFont(`${fontfamily}`, `${fontstyle}`, `${fontweight}`);
              } else {
                let fontFile = "Normal";
                if (fontweight === "bold") {
                  fontFile = "Bold";
                }
                if (fontstyle === "italic") {
                  fontFile = `${fontFile}Italic`;
                }

                let fontFileName = `${fontfamily}-${fontFile}`;
                if (!_.includes(fileImported, fontFileName)) {
                  fileImported.push(fontFileName);
                  let importFont = `${MAIN_URL}/assets/fonts/${fontFileName}.ttf`;
                  doc.addFont(`${importFont}`, `${fontfamily}`, "normal");
                }
                doc.setFont(`${fontfamily}`);
              }
              doc.setFontSize(fontsize);
              doc.setTextColor(`${textcolor}`);

              if (ismiddle == 1) {
                doc.text(`${textVal}`, templateX, templateY + fontsize, {
                  align: "center",
                  maxWidth: boxWidth,
                });
              } else {
                doc.text(`${textVal}`, templateX, templateY + fontsize);
              }
            }

            // console.log("multiplyX :- ", multiplyX);
            // console.log("multiplyY :- ", multiplyY);
            // console.log("templateX :- ", templateX);
            // console.log("templateY :- ", templateY);
            // console.log("template data :- ", template.name);
          }
        });
        // console.log("----------------------------------");

        // Get the column no. of each row and update that. update the multiplyX for calculate the each badge x position. Used above
        if (columnCount <= columnInRow) {
          multiplyX++;
          columnCount++;
        } else {
          multiplyX = 0;
          columnCount = 1;
        }

        // Get the row for each page and update. update the multiplyX and multiplyY for calculate the each badge x, y position. Used above
        if (columnCount > columnInRow) {
          pageRowNumber++;
          multiplyY++;
          multiplyX = 0;
          columnCount = 1;
        }

        // Add new page if all users are not printed and reset the all used variable used for calculation
        if (pageRowNumber > rowsInPage) {
          if (selectedUsers.length - 1 > index)
            doc.addPage([pageWidth, pageHeight], orientation);

          pageRowNumber = 1;
          columnCount = 1;
          multiplyY = 0;
          multiplyX = 0;
        }
      });

      this.setState({ loading: false });
      if (values.badgefor === "choose_attendees") {
        this.setState({ selectedUsers: [], allCheck: false });
      }

      doc.save("usersbadges.pdf");
    });
  }

  // Generating single badge locally
  generateSingleBadge = (values) => {
    // console.log("values :- ", values);
    let { currentTemplateId, badgeList, eventDetails } = this.props;
    var selectedUsers = [values];

    var selcted = _.filter(badgeList.data, (obj) => {
      return obj.badgeid == currentTemplateId;
    });
    var selctedBadge = selcted[0];
    // console.log("selctedBadge - ", selctedBadge);

    var badgeSize = selctedBadge.badge_size;
    var templateData = JSON.parse(selctedBadge.template); // String to json parse for template
    templateData.reverse(); // Only for z-index, as last element in array will be in last indexing;
    // console.log("templateData - ", templateData);

    // Get badhe size (W * H)
    var badgeSizeArray = _.split(badgeSize, "#");
    var boxWidth = parseFloat(
      convertToPixel(selctedBadge.measurement, badgeSizeArray[0])
    );
    var boxHeight = parseFloat(
      convertToPixel(selctedBadge.measurement, badgeSizeArray[1])
    );

    var orientation = "p";
    if (boxWidth > boxHeight) {
      orientation = "l";
    }
    const doc = new jsPDF(orientation, "pt", [boxWidth, boxHeight]);

    var allqrDataArr = [];
    var promiseArray = [];
    _.forEach(selectedUsers, (user, index) => {
      promiseArray.push(
        new Promise(async (resolve, reject) => {
          var magicurlqr = user.userqrstring;
          var qrdata = await QRCode.toDataURL(magicurlqr, {
            margin: 0,
          });
          allqrDataArr.push(qrdata);
          resolve();
        })
      );
    });

    let fileImported = [];
    Promise.all(promiseArray).then(() => {
      // console.log("allqrDataArr", allqrDataArr);

      _.forEach(selectedUsers, (user, index) => {
        user.eventname = eventDetails.eventname;
        user.eventicon = eventDetails.eventicon;
        user.country = eventDetails.country;
        var eventlogowidth = 50;
        var eventlogohight = 50;
        var qrwidth = 50;
        var qrhight = 50;
        var customimagewidth = boxWidth;
        var customimagehight = boxHeight;
        var mylink = allqrDataArr[index];

        _.forEach(templateData, (template) => {
          // console.log("template :- ", template);
          var fontsize = DEFAULTFONTSIZE.replace(/\D/g, "");
          var fontweight = DEFAULTFONTWEIGHT;
          var fontfamily = DEFAULTFONTFAMILY;
          var fontstyle = "";
          var textdecoration = "";
          var texttransform = "none";
          var textcolor = "#000000";

          var templateX = template.x / 2;
          var templateY = template.y / 2;

          // Only show those which hidden key value is 'false' in json
          if (!template.hidden) {
            var ismiddle = 0;

            // Check the style set for current field
            _.forEach(template.style, (stylevalue, styleKey) => {
              var stVal = "";
              if (
                stylevalue !== null &&
                stylevalue !== "null" &&
                stylevalue !== "" &&
                styleKey !== "border"
              ) {
                if (
                  template.htmlType === "div" ||
                  template.htmlType === "input"
                ) {
                  if (styleKey === "fontSize") {
                    stVal = stylevalue.replace(/\D/g, ""); // replace pxfrom style value to divide by 2
                    fontsize = stVal / 2;
                  } else {
                    stVal = stylevalue;
                  }

                  if (styleKey === "fontWeight") {
                    fontweight = stVal;
                  }
                  if (styleKey === "fontFamily") {
                    fontfamily = stVal;
                  }
                  if (styleKey === "fontStyle") {
                    fontstyle = stVal;
                  }
                  if (styleKey === "textDecoration") {
                    textdecoration = stVal;
                  }
                  if (styleKey === "textTransform") {
                    texttransform = stVal;
                  }
                  if (styleKey === "color") {
                    textcolor = stVal;
                  }
                  if (styleKey === "textAlign" && stylevalue === "center") {
                    templateX = 0;
                    ismiddle = 1; // -> JS PART
                  }
                } else {
                  if (styleKey === "width" || styleKey === "height") {
                    stVal = stylevalue / 2;

                    if (styleKey === "width") {
                      if (template.name === "#qr_code") {
                        qrwidth = stVal;
                      }
                      if (template.name === "#event_logo") {
                        eventlogowidth = stVal;
                      }
                      if (template.iscustom && template.htmlType === "image") {
                        customimagewidth = stVal;
                      }
                    }

                    if (styleKey === "height") {
                      if (template.name === "#qr_code") {
                        qrhight = stVal;
                      }
                      if (template.name === "#event_logo") {
                        eventlogohight = stVal;
                      }
                      if (template.iscustom && template.htmlType === "image") {
                        customimagehight = stVal;
                      }
                    }
                  } else {
                    stVal = stylevalue;
                  }
                }
              }
            });

            // FOR EVENT LOG
            if (template.name === "#event_logo") {
              var event_log_src = `${BASE_IMAGES_URL}/${user.eventicon}?api_key=${ACCESS_FILES_API_KEY}`;
              let imgData = event_log_src;

              doc.addImage(
                imgData,
                "JPEG",
                templateX,
                templateY,
                eventlogowidth,
                eventlogohight
              );
            } else if (template.iscustom && template.htmlType === "image") {
              var customimage = `${BASE_IMAGES_URL}/${template.imageValue}?api_key=${ACCESS_FILES_API_KEY}`;
              let imgData = customimage;

              doc.addImage(
                imgData,
                "JPEG",
                templateX,
                templateY,
                customimagewidth,
                customimagehight
              );
            } else if (template.name === "#qr_code") {
              var magicurlqr = user.userqrstring;
              // var mylink = `${INSTANCE_URL}/qrcode.php?s=qr&d=${magicurlqr}&sf=10&ms=r&md=1&wq=0&h=500&w=500`;
              let imgData = mylink;
              // console.log("imgData :- ", imgData);

              doc.addImage(
                imgData,
                "JPEG",
                templateX,
                templateY,
                qrwidth,
                qrhight
              );
            } else if (template.htmlType === "input") {
              // For any input type
              let getVal = this.tagToNameFc(template, user);
              let textVal =
                texttransform == "uppercase" ? getVal.toUpperCase() : getVal;
              // let textVal =
              //   texttransform == "uppercase"
              //     ? template.textValue.toUpperCase()
              //     : template.textValue;

              if (fontfamily == "Helvetica") {
                doc.setFont(`${fontfamily}`, `${fontstyle}`, `${fontweight}`);
              } else {
                let fontFile = "Normal";
                if (fontweight === "bold") {
                  fontFile = "Bold";
                }
                if (fontstyle === "italic") {
                  fontFile = `${fontFile}Italic`;
                }

                let fontFileName = `${fontfamily}-${fontFile}`;
                if (!_.includes(fileImported, fontFileName)) {
                  fileImported.push(fontFileName);
                  let importFont = `${MAIN_URL}/assets/fonts/${fontFileName}.ttf`;
                  doc.addFont(`${importFont}`, `${fontfamily}`, "normal");
                }
                doc.setFont(`${fontfamily}`);
              }
              doc.setFontSize(fontsize);
              doc.setTextColor(`${textcolor}`);

              if (ismiddle == 1) {
                let getPageWidth =
                  doc.internal.pageSize.width ||
                  doc.internal.pageSize.getWidth();
                doc.text(`${textVal}`, getPageWidth / 2, templateY + fontsize, {
                  align: "center",
                  maxWidth: getPageWidth,
                });
              } else {
                doc.text(`${textVal}`, templateX, templateY + fontsize);
              }
            } else {
              let getVal = this.tagToNameFc(template, user);
              let textVal =
                texttransform == "uppercase" ? getVal.toUpperCase() : getVal;

              if (fontfamily == "Helvetica") {
                doc.setFont(`${fontfamily}`, `${fontstyle}`, `${fontweight}`);
              } else {
                let fontFile = "Normal";
                if (fontweight === "bold") {
                  fontFile = "Bold";
                }
                if (fontstyle === "italic") {
                  fontFile = `${fontFile}Italic`;
                }

                let fontFileName = `${fontfamily}-${fontFile}`;
                if (!_.includes(fileImported, fontFileName)) {
                  fileImported.push(fontFileName);
                  let importFont = `${MAIN_URL}/assets/fonts/${fontFileName}.ttf`;
                  doc.addFont(`${importFont}`, `${fontfamily}`, "normal");
                }
                doc.setFont(`${fontfamily}`);
              }
              doc.setFontSize(fontsize);
              doc.setTextColor(`${textcolor}`);

              if (ismiddle == 1) {
                let getPageWidth =
                  doc.internal.pageSize.width ||
                  doc.internal.pageSize.getWidth();
                doc.text(`${textVal}`, getPageWidth / 2, templateY + fontsize, {
                  align: "center",
                  maxWidth: getPageWidth,
                });
              } else {
                doc.text(`${textVal}`, templateX, templateY + fontsize);
              }
            }
          }
        });
        if (selectedUsers.length - 1 > index) {
          doc.addPage([boxWidth, boxHeight], orientation);
        }
      });

      doc.save(`${selectedUsers[0].firstname}.pdf`);
    });
  };

  // Set search text
  setSearch(value) {
    let { session } = this.props;
    let { badgeFor, selectedCategoryObj } = this.state;
    // console.log("search user for badge :- ", value);

    let sort =
      badgeFor === "specific_category" && selectedCategoryObj.id !== ""
        ? selectedCategoryObj.id
        : "all";

    if (value === "") {
      /*
        Blank search then [When user remove search text from search box]
        Default fetch users
      */

      this.apiCallForBadgeUsers({
        sort: sort,
        pageNumber: 1,
        perPage: LISTPERPAGE,
      });
    } else {
      // Search word present
      this.apiCallForBadgeUsers({
        sort: sort,
        search: value,
        pageNumber: 1,
        perPage: LISTPERPAGE,
      });
    }

    this.setState({ search: value, pageNumber: 1 });
  }

  /* 
    Handel Generate badge for
  */
  _handleGenerateBadgeFor = (e) => {
    let { userList, userCategoryList, session } = this.props;
    let { selectedCategoryObj } = this.state;
    let value = e.target.value;
    // console.log("Badge generate for :- ", value);

    this.setState({ badgeFor: value });
    this.reinitializeInternalStates();

    // In case of any change in main page pagenumber / offset will start from 1 && make blank [] user not in array
    if (value === "all_attendees" || value === "choose_attendees") {
      /*  All category -> Selected */

      this.apiCallForBadgeUsers({
        sort: "all",
        pageNumber: 1,
        perPage: LISTPERPAGE,
      });
    } else if (value === "specific_category") {
      // Specific category

      if (userCategoryList && userCategoryList.data) {
        // console.log("userCategoryList :- ", userCategoryList);
        let firstObjet = userCategoryList.data[0]; // First Object for selection
        selectedCategoryObj.id = firstObjet.id;
        selectedCategoryObj.name = firstObjet.type;
        let obj = {
          name: firstObjet.groupname,
          value: _.lowerCase(firstObjet.groupname) + "#" + firstObjet.id,
        };

        this.setState({ selectedCategoryObj });
        // Select the "Attendee" for first time "Specific category" selection
        this.props.dispatch(change("generateBadgeForm", "category", obj.value));

        this.apiCallForBadgeUsers({
          sort: firstObjet.id,
          pageNumber: 1,
          perPage: LISTPERPAGE,
        });
      }
    }
  };

  /*
    Handel category selection
  */
  _handleCategorySelection = (e) => {
    let { selectedCategoryObj, pageNumber } = this.state;
    let { session } = this.props;
    var value = e.target.value;
    // console.log("selected category :- ", value);

    if (value) {
      // Update state object // Value like "attendee#1706324568467740"
      let dataArray = _.split(value, "#");
      var catID = dataArray.pop();
      selectedCategoryObj.id = catID;
      selectedCategoryObj.name = dataArray[0];

      /* 
      Call user list depending on "Select a category" Example = |Speaker/Attendee/Sponcers etc| 
    */
      this.apiCallForBadgeUsers({
        sort: catID,
        pageNumber: pageNumber,
        perPage: LISTPERPAGE,
      });
    } else {
      // Empty string => select a category text [Reinitialize state]
      selectedCategoryObj.id = "";
      selectedCategoryObj.name = "";

      /* 
        Call user list depending on "Select a category" Example = |Speaker/Attendee/Sponcers etc| 
      */

      this.apiCallForBadgeUsers({
        sort: "all",
        pageNumber: pageNumber,
        perPage: LISTPERPAGE,
      });
    }

    /* 
      Update state object
      Note :- In case of any chnage in main page page number / offset will start from 1
    */
    this.setState({ selectedCategoryObj, pageNumber: 1 });
  };

  paginationCallback = (pageNumber) => {
    let { session } = this.props;
    let { search, badgeFor, selectedCategoryObj } = this.state;

    let sort =
      badgeFor === "specific_category" && selectedCategoryObj.id !== ""
        ? selectedCategoryObj.id
        : "all";

    if (search === "") {
      this.apiCallForBadgeUsers({
        sort: sort,
        pageNumber: pageNumber,
        perPage: LISTPERPAGE,
      });
    } else {
      // Search
      this.apiCallForBadgeUsers({
        sort: sort,
        search: search,
        pageNumber: pageNumber,
        perPage: LISTPERPAGE,
      });
    }
    setTimeout(() => {
      this.setState({ ...this.state, pageNumber });
    }, 1000);
  };

  apiCallForBadgeUsers = (dataObj) => {
    let { session } = this.props;
    let { selectedUsers } = this.state;
    // console.log("dataObj :- ", dataObj);

    if (dataObj.search) {
      if (dataObj.search.length > 3) {
        this.props.blankBadgeUserList(); // Clear user list

        this.props.SearchUsersForGenerateBadge(
          session,
          dataObj.sort,
          dataObj.search,
          dataObj.pageNumber,
          dataObj.perPage,
          (callback) => {
            setTimeout(() => {
              this.checkMatchArray(selectedUsers);
            }, 100);
          }
        );
      }
    } else {
      this.props.blankBadgeUserList(); // Clear user list

      this.props.sortListUserByCategory(
        session,
        dataObj.sort,
        dataObj.pageNumber,
        dataObj.perPage,
        (callback) => {
          setTimeout(() => {
            this.checkMatchArray(selectedUsers);
          }, 100);
        }
      );
    }
  };

  // Selecting one one user
  updateSelectedUser = (user) => {
    var selectedUsers = this.state.selectedUsers;
    var index = _.findIndex(selectedUsers, function (curuser) {
      return curuser.appuserid === user.appuserid;
    });

    if (index >= 0) {
      var newSelectedUsers = _.filter(selectedUsers, function (selusers) {
        return selusers.appuserid !== user.appuserid;
      });

      this.checkMatchArray(newSelectedUsers);
      this.setState({ selectedUsers: newSelectedUsers });
    } else {
      if (!user.deleted) {
        var newSelectUser = { ...user, checked: true };
        selectedUsers = [...selectedUsers, newSelectUser];
      }

      this.checkMatchArray(selectedUsers);
      this.setState({ selectedUsers });
    }
  };

  // Here we are looping user who are visiable on screen only
  selectAllUsers = () => {
    var state = this.state.allCheck;
    var selectedUsers = this.state.selectedUsers;
    var allUsers = this.props.userList.data;
    var newSelectUser = [];
    var newSelectedUsers = [];

    if (state == false) {
      _.map(allUsers, (user) => {
        var checkUserExitOrNot = _.filter(selectedUsers, function (selusers) {
          return selusers.appuserid === user.appuserid;
        });

        //Check if user is not exist in selected user then add
        if (checkUserExitOrNot.length == 0) {
          newSelectUser = { ...user, checked: true };
          selectedUsers = [...selectedUsers, newSelectUser];
        }
        this.checkMatchArray(selectedUsers);
        this.setState({ selectedUsers });
      });
    } else {
      var leftUsers = selectedUsers;
      _.map(allUsers, (user) => {
        newSelectedUsers = _.filter(leftUsers, function (selusers) {
          return selusers.appuserid !== user.appuserid;
        });
        leftUsers = newSelectedUsers;

        this.checkMatchArray(leftUsers);
        this.setState({ selectedUsers: leftUsers });
      });
    }
  };

  // This function is used to show or hide action option and check or uncheck master check field
  checkMatchArray = (selectedUsers) => {
    this.setState({ allCheck: false });
    // console.log("selectedUsers :- ", selectedUsers);
    var userList = this.props.userList.data;
    // console.log("userList :- ", userList);
    var newArray = [];
    _.map(userList, (appUser) => {
      var newSelectedUsers = _.filter(selectedUsers, function (selusers) {
        return selusers.appuserid === appUser.appuserid;
      });

      if (newSelectedUsers && newSelectedUsers.length > 0) {
        newArray = [...newArray, newSelectedUsers];
      }
    });

    // Check for all user selected or not according to that check or uncheck master check option
    if (newArray.length > 0 && newArray.length === userList.length) {
      this.setState({ allCheck: true });
    } else {
      this.setState({ allCheck: false });
    }
  };

  // On print type option changed
  handlePrintType = () => {
    this.props.change("page_size", PAGEDEFAULTSIZE);
    this.props.change("pagewidth", 0);
    this.props.change("pageheight", 0);
    this.props.change("page_padding_top", 0);
    this.props.change("page_padding_left", 0);
    this.props.change("column_spacing", 0);
    this.props.change("row_spacing", 0);
  };

  handleCalculationType = (e) => {
    let type = e.target.value;
    let {
      pageCustomWidth,
      pageCustomHeight,
      pagePaddingTop,
      pagePaddingLeft,
      columnSpacing,
      rowSpacing,
    } = this.props;

    let CW = 0;
    let CH = 0;
    let PPT = 0;
    let PPL = 0;
    let CS = 0;
    let RS = 0;
    if (type === "cm") {
      CW = pageCustomWidth > 0 ? inchToCent(pageCustomWidth).toFixed(2) : 0;
      CH = pageCustomHeight > 0 ? inchToCent(pageCustomHeight).toFixed(2) : 0;
      PPT = pagePaddingTop > 0 ? inchToCent(pagePaddingTop).toFixed(2) : 0;
      PPL = pagePaddingLeft > 0 ? inchToCent(pagePaddingLeft).toFixed(2) : 0;
      CS = columnSpacing > 0 ? inchToCent(columnSpacing).toFixed(2) : 0;
      RS = rowSpacing > 0 ? inchToCent(rowSpacing).toFixed(2) : 0;
    } else if (type === "inch") {
      CW = pageCustomWidth > 0 ? centToInch(pageCustomWidth).toFixed(2) : 0;
      CH = pageCustomHeight > 0 ? centToInch(pageCustomHeight).toFixed(2) : 0;
      PPT = pagePaddingTop > 0 ? centToInch(pagePaddingTop).toFixed(2) : 0;
      PPL = pagePaddingLeft > 0 ? centToInch(pagePaddingLeft).toFixed(2) : 0;
      CS = columnSpacing > 0 ? centToInch(columnSpacing).toFixed(2) : 0;
      RS = rowSpacing > 0 ? centToInch(rowSpacing).toFixed(2) : 0;
    }

    this.props.change("pagewidth", CW);
    this.props.change("pageheight", CH);
    this.props.change("page_padding_top", PPT);
    this.props.change("page_padding_left", PPL);
    this.props.change("column_spacing", CS);
    this.props.change("row_spacing", RS);
  };

  /* On page size change from options */
  _handelPageSizeChange(e) {
    this.props.change("pagewidth", "");
    this.props.change("pageheight", "");
  }

  renderBadges = (columns, rows, boxWidth, boxHeight, columnSpacing) => {
    let badgeData = [];

    let badgeNo = 1;
    for (let row = 0; row < rows; row++) {
      let colData = [];
      for (let col = 0; col < columns; col++) {
        let obj = (
          <div
            key={`badge_dummy_key${badgeNo}`}
            className="badge-generate-preview-badge"
            style={{
              width: `${boxWidth / 2}px`,
              height: `${boxHeight / 2}px`,
            }}
          >
            {LocaleStrings.badge} {badgeNo}
          </div>
        );

        badgeNo++;
        colData.push(obj);
      }
      let rowObj = (
        <div
          key={`badge_row_dummy_key${row}`}
          className="badge-generate-preview-row"
          style={{ columnGap: `${columnSpacing / 2}px` }}
        >
          {colData}
        </div>
      );
      badgeData.push(rowObj);
    }

    return badgeData;
  };

  render() {
    let { badgeFor, search, selectedUsers, pageNumber, loading } = this.state;
    var {
      handleSubmit,
      pristine,
      submitting,
      invalid,
      isGenerateBadgeModalOpen,
      userCategoryList,
      userList,
      currentTemplateId,
      badgeList,
      printType,
      calculationType,
      pageSize,
      pageCustomWidth,
      pageCustomHeight,
      pagePaddingTop,
      pagePaddingLeft,
      columnSpacing,
      rowSpacing,
    } = this.props;

    var totalPrint =
      badgeFor === "choose_attendees" ? selectedUsers.length : userList.count;

    let categoryOptions = [];
    if (userCategoryList && userCategoryList.data) {
      _.forEach(userCategoryList.data, (category, cateindex) => {
        let obj = {
          name: category.groupname,
          value: _.lowerCase(category.groupname) + "#" + category.id,
        };
        categoryOptions.push(obj);
      });
    }
    // console.log("printType :- ", printType);
    // console.log("calculationType :- ", calculationType);
    // console.log("pageSize :- ", pageSize);

    // Below code is used for badge print preview for multiple print //
    // Get selected badge template
    var selctedTemp = _.filter(badgeList.data, (obj) => {
      return obj.badgeid == currentTemplateId;
    });
    // console.log("Selcted template :- ", selctedTemp);

    // Get badge size (W * H)
    var badgeSize =
      selctedTemp.length > 0 ? selctedTemp[0].badge_size : BADGEDEFAULTSIZE;
    var badgeSizeArray = _.split(badgeSize, "#");
    var boxWidth = convertToPixel("cm", badgeSizeArray[0]).toFixed(2);
    var boxHeight = convertToPixel("cm", badgeSizeArray[1]).toFixed(2);

    if (selctedTemp.length > 0) {
      badgeSize = selctedTemp[0].badge_size;

      var badgeSizeArray = _.split(badgeSize, "#");
      var boxWidth = convertToPixel(
        selctedTemp[0].measurement,
        badgeSizeArray[0]
      ).toFixed(2);
      var boxHeight = convertToPixel(
        selctedTemp[0].measurement,
        badgeSizeArray[1]
      ).toFixed(2);
    }

    // console.log("boxWidth :- ", boxWidth);
    // console.log("boxHeight :- ", boxHeight);

    // Get page size (W * H)
    var pageWidth = 0;
    var pageHeight = 0;
    if (pageSize === "custom") {
      // convertToPixel -> is used to convert any value in pixel as per calculationType. As we are allowing end user to enter custom W*H
      pageWidth = convertToPixel(
        calculationType,
        pageCustomWidth < 0 ? 0 : pageCustomWidth
      ).toFixed(2);
      pageHeight = convertToPixel(
        calculationType,
        pageCustomHeight < 0 ? 0 : pageCustomHeight
      ).toFixed(2);
    } else {
      // Here we are using centToPixel function because we have dufault value in cm, So here we no need convertToPixel function to use.
      let pageSizeArray = _.split(pageSize, "#");
      pageWidth = centToPixel(pageSizeArray[0]).toFixed(2);
      pageHeight = centToPixel(pageSizeArray[1]).toFixed(2);
    }

    // console.log("Original pageWidth :- ", pageWidth);
    // console.log("Original pageHeight :- ", pageHeight);

    // Get the page padding
    pagePaddingTop = convertToPixel(
      calculationType,
      pagePaddingTop < 0 ? 0 : pagePaddingTop
    ).toFixed(2);
    pagePaddingLeft = convertToPixel(
      calculationType,
      pagePaddingLeft < 0 ? 0 : pagePaddingLeft
    ).toFixed(2);

    // console.log("pagePaddingTop :- ", pagePaddingTop);
    // console.log("pagePaddingLeft :- ", pagePaddingLeft);

    // Reduce the page padding from page size
    var finalPageWidth = (pageWidth - pagePaddingLeft).toFixed(2);
    var finalPageHeight = (pageHeight - pagePaddingTop).toFixed(2);

    // console.log("Padding Reduce pageWidth :- ", finalPageWidth);
    // console.log("Padding Reduce pageHeight :- ", finalPageHeight);

    // Get the badges in each row and rows in each page befor col & row spacing
    var columnInRow = Math.floor(finalPageWidth / boxWidth);
    var rowsInPage = Math.floor(finalPageHeight / boxHeight);

    // console.log("Before column spacing columnInRow :- ", columnInRow);
    // console.log("Before row spacing rowsInPage :- ", rowsInPage);

    // Get the column & row spacing
    columnSpacing = convertToPixel(
      calculationType,
      columnSpacing < 0 ? 0 : columnSpacing
    ).toFixed(2);
    rowSpacing = convertToPixel(
      calculationType,
      rowSpacing < 0 ? 0 : rowSpacing
    ).toFixed(2);

    // console.log("columnSpacing :- ", columnSpacing);
    // console.log("rowSpacing :- ", rowSpacing);

    // Get total column & row spacing. Here -1 is because row and column space is added between 2 badge only 1 time.
    var pageColumnSpacing = (columnSpacing * (columnInRow - 1)).toFixed(2);
    var pageRowSpacing = (rowSpacing * (rowsInPage - 1)).toFixed(2);

    // console.log("pageColumnSpacing :- ", pageColumnSpacing);
    // console.log("pageRowSpacing :- ", pageRowSpacing);

    // reduce the column & row spacing from page width and height
    finalPageWidth = (finalPageWidth - pageColumnSpacing).toFixed(2);
    finalPageHeight = (finalPageHeight - pageRowSpacing).toFixed(2);

    // console.log("Column spacing Reduce pageWidth :- ", finalPageWidth);
    // console.log("Row spacing  Reduce pageHeight :- ", finalPageHeight);

    // Get the final column in each row and row in each page
    columnInRow = Math.floor(finalPageWidth / boxWidth);
    rowsInPage = Math.floor(finalPageHeight / boxHeight);

    // console.log("columnInRow :- ", columnInRow);
    // console.log("rowsInPage :- ", rowsInPage);
    // console.log("====================================");

    // For page preview, we are displying 50% of actual size.
    var pagePreview = {
      width: `${pageWidth / 2}px`,
      height: `${pageHeight / 2}px`,
      paddingTop: `${pagePaddingTop / 2}px`,
      paddingLeft: `${pagePaddingLeft / 2}px`,
      rowGap: `${rowSpacing / 2}px`,
    };
    // Above code is used for badge print preview for multiple print //

    return (
      <div>
        <Modal
          className="modal-container custom-full-screen-modal badge-modal generate-badge-modal"
          dialogClassName="modal-xl"
          show={isGenerateBadgeModalOpen}
          onHide={this.closeModal}
          animation={true}
        >
          <form
            onSubmit={handleSubmit(this.onFormSubmit.bind(this))}
            encType="multipart/form-data"
          >
            <Modal.Header>
              <div className="vertical-align-center gap-3">
                <div className="import-modal-title">
                  {
                    LocaleStrings.dashboard_badgedesign_generate_badge_modal_header
                  }
                </div>
                <Field
                  label={
                    LocaleStrings.dashboard_badgedesign_generate_printtype_option1
                  }
                  name="printtype"
                  type="radio"
                  value="single"
                  component={this.renderFieldRadio}
                  onChange={this.handlePrintType}
                />
                <Field
                  label={
                    LocaleStrings.dashboard_badgedesign_generate_printtype_option2
                  }
                  name="printtype"
                  type="radio"
                  value="multiple"
                  component={this.renderFieldRadio}
                  onChange={this.handlePrintType}
                />
                <BetaFeature />
              </div>
              <button
                type="button"
                className="i-custom-cross-popup pull-right"
                onClick={() => this.closeModal()}
              >
                <img
                  className="i-custom-small"
                  src={`${IMAGE_PATH}custom-icons/cross-black.png`}
                  alt="cross"
                />
              </button>
            </Modal.Header>
            <Modal.Body>
              {/* For multiple badge print setting and preview */}
              {printType === "multiple" ? (
                <Row className="m-0 border-bottom">
                  <Col
                    sm={3}
                    className="border-right p-20"
                    style={{ backgroundColor: "white" }}
                  >
                    <Row>
                      <Col sm={6}>
                        <Field
                          label={LocaleStrings.cm}
                          name="calculatein"
                          type="radio"
                          value="cm"
                          component={this.renderFieldRadio}
                          onChange={this.handleCalculationType}
                        />
                      </Col>
                      <Col sm={6}>
                        <Field
                          label={LocaleStrings.inch}
                          name="calculatein"
                          type="radio"
                          value="inch"
                          component={this.renderFieldRadio}
                          onChange={this.handleCalculationType}
                        />
                      </Col>
                    </Row>
                    {/* Page size */}
                    <Field
                      name={"page_size"}
                      label={
                        LocaleStrings.dashboard_badgedesign_form_label_page_size
                      }
                      placeholder={
                        LocaleStrings.dashboard_badgedesign_form_page_size
                      }
                      component={this.renderSelect}
                      mandatory="true"
                      opts={PAGESIZEOPTIONS}
                      onChange={(e) => this._handelPageSizeChange(e)}
                      labelposition={LABEL_POSITION_TOP}
                    />
                    {/* Toggle between custom and default page */}
                    {pageSize === "custom" ? (
                      <div className="custom-badge-size-box mb-10">
                        <Row>
                          <Col sm={12}>
                            <label className="control-label-top col-sm-12">
                              {
                                LocaleStrings.dashboard_badgedesign_form_label_custom_page_size
                              }
                              <span className="label-mandatory">*</span>
                            </label>
                          </Col>
                          <Col sm={6}>
                            <Field
                              name="pagewidth"
                              placeholder={
                                LocaleStrings.dashboard_badgedesign_form_ph_custom_page_size
                              }
                              type="number"
                              mandatory="true"
                              min="8.89"
                              labelposition={LABEL_POSITION_TOP}
                              component={this.renderFieldText}
                            />
                          </Col>
                          <Col sm={6}>
                            <Field
                              name="pageheight"
                              placeholder={
                                LocaleStrings.dashboard_badgedesign_form_ph_custom_page_size
                              }
                              type="number"
                              mandatory="true"
                              min="4.44"
                              labelposition={LABEL_POSITION_TOP}
                              component={this.renderFieldText}
                            />
                          </Col>
                        </Row>
                      </div>
                    ) : (
                      ""
                    )}

                    {/* Page Padding*/}
                    <Row>
                      <Col sm={6}>
                        <Field
                          name="page_padding_top"
                          label={
                            LocaleStrings.dashboard_badgedesign_form_label_page_padding_top
                          }
                          placeholder={
                            LocaleStrings.dashboard_badgedesign_form_ph_page_padding_top
                          }
                          type="number"
                          mandatory="false"
                          min="0"
                          labelposition={LABEL_POSITION_TOP}
                          component={this.renderFieldText}
                        />
                      </Col>
                      <Col sm={6}>
                        <Field
                          name="page_padding_left"
                          label={
                            LocaleStrings.dashboard_badgedesign_form_label_page_padding_left
                          }
                          placeholder={
                            LocaleStrings.dashboard_badgedesign_form_ph_page_padding_left
                          }
                          type="number"
                          mandatory="false"
                          min="0"
                          labelposition={LABEL_POSITION_TOP}
                          component={this.renderFieldText}
                        />
                      </Col>
                    </Row>

                    {/* Spacing row & column */}
                    <Row>
                      <Col sm={6}>
                        <Field
                          name="column_spacing"
                          label={
                            LocaleStrings.dashboard_badgedesign_form_label_column_spacing
                          }
                          placeholder={
                            LocaleStrings.dashboard_badgedesign_form_ph_column_spacing
                          }
                          type="number"
                          mandatory="false"
                          min="0"
                          labelposition={LABEL_POSITION_TOP}
                          component={this.renderFieldText}
                        />
                      </Col>
                      <Col sm={6}>
                        <Field
                          name="row_spacing"
                          label={
                            LocaleStrings.dashboard_badgedesign_form_label_row_spacing
                          }
                          placeholder={
                            LocaleStrings.dashboard_badgedesign_form_ph_row_spacing
                          }
                          type="number"
                          mandatory="false"
                          min="0"
                          labelposition={LABEL_POSITION_TOP}
                          component={this.renderFieldText}
                        />
                      </Col>
                    </Row>
                  </Col>

                  <Col sm={9} className="p-0">
                    <div className="badge-generate-preview-container">
                      <div
                        className="badge-generate-preview-page"
                        style={pagePreview}
                      >
                        {this.renderBadges(
                          columnInRow,
                          rowsInPage,
                          boxWidth,
                          boxHeight,
                          columnSpacing
                        )}
                      </div>
                    </div>
                  </Col>
                </Row>
              ) : (
                ""
              )}

              {/* User list to pring badge */}
              <Row className="m-0 h-full">
                <Col
                  sm={3}
                  className="border-right p-20"
                  style={{ backgroundColor: "white" }}
                >
                  {/* Generate badge for */}
                  <div className="control-label-top">
                    {
                      LocaleStrings.dashboard_badgedesign_form_label_generate_badge_for
                    }
                  </div>
                  {_.map(badgeForOptions, (opt, index) => {
                    return opt.value !== "all_attendees" ? (
                      <Field
                        key={`badge_for_key_${index}`}
                        name={"badgefor"}
                        label={opt.text}
                        value={opt.value}
                        formdiv="mt-10 mb-10"
                        type="radio"
                        component={this.renderFieldRadio}
                        onChange={(e) => this._handleGenerateBadgeFor(e)}
                      />
                    ) : (
                      ""
                    );
                  })}
                  {/*
                     Lebal- Select a category
                     Note : - Will show this button when "Generate badge for"="Specific category"
                     Note : - Category List from -> appuser_groups?include_count=true&filter=eventid
                  */}
                  {badgeFor === "specific_category" ? (
                    <Field
                      name={"category"}
                      placeholder={
                        LocaleStrings.dashboard_badgedesign_form_ph_category
                      }
                      component={this.renderSelect}
                      mandatory={false}
                      opts={categoryOptions}
                      labelposition={LABEL_POSITION_TOP}
                      onChange={(e) => this._handleCategorySelection(e)}
                    />
                  ) : (
                    ""
                  )}
                  {_.map(badgeForOptions, (opt, index) => {
                    return opt.value === "all_attendees" ? (
                      <Field
                        key={`badge_for_key_${index}`}
                        name={"badgefor"}
                        label={opt.text}
                        value={opt.value}
                        formdiv="mt-10 mb-10"
                        type="radio"
                        component={this.renderFieldRadio}
                        onChange={(e) => this._handleGenerateBadgeFor(e)}
                      />
                    ) : (
                      ""
                    );
                  })}

                  {/* <div>
                    <Field
                      name="pdfsettings"
                      label={
                        LocaleStrings.dashboard_badgedesign_form_label_pdf_settings
                      }
                      component={this.renderFieldCheckbox}
                      mandatory="false"
                      type="checkbox"
                      className="cust-check-box"
                      classNameLabel="text-box-lable"
                    />
                    <p className="mt-1 text-sm text-tarnary">
                      {LocaleStrings.dashboard_badgedesign_form_pdf_settings}
                    </p>
                  </div> */}
                </Col>
                <Col sm={9} className="px-0 pb-3">
                  {/* Hearder component */}
                  <GenerateBadgeHeader
                    history={this.props.history}
                    badgeFor={badgeFor}
                    search={search} // Current search text
                    setSearch={(e) => this.setSearch(e)} // Update search
                  />

                  {/* Generate badge user table component*/}
                  <GenerateBadgeUsersTable
                    history={this.props.history}
                    badgeFor={badgeFor}
                    pageNumber={pageNumber} // Update pagenumber
                    pagination={this.paginationCallback}
                    allCheck={this.state.allCheck}
                    selectedUsers={this.state.selectedUsers}
                    checkAndUncheckUsers={this.updateSelectedUser}
                    checkAndUncheckAllUsers={this.selectAllUsers}
                    printSingleBadge={this.generateSingleBadge}
                  />
                </Col>
              </Row>
            </Modal.Body>
            <Modal.Footer>
              {loading ? (
                <div className="custom-text1-primary-normal">
                  {
                    LocaleStrings.dashboard_badgedesign_generate_badge_wait_message
                  }
                </div>
              ) : (
                ""
              )}
              <Button
                className="btn btn-custom-blue ml-10"
                loading={loading}
                disabled={invalid || submitting}
                // Old code - disabled={pristine || invalid || submitting}
                type="submit"
              >
                {LocaleStrings.dashboard_badgedesign_generate_btn}{" "}
                {totalPrint > 1
                  ? `${totalPrint} ${LocaleStrings.users.toLowerCase()}`
                  : totalPrint == 1
                  ? `${totalPrint} ${LocaleStrings.user.toLowerCase()}`
                  : ""}
              </Button>
            </Modal.Footer>
          </form>
        </Modal>
      </div>
    );
  }
}

const selector = formValueSelector("generateBadgeForm");

function mapStateToProps(state, ownProps) {
  let cal = "cm";
  if (state.dashboardBadgeList && ownProps.currentTemplateId) {
    var selcted = _.filter(state.dashboardBadgeList.data, (obj) => {
      return obj.badgeid == ownProps.currentTemplateId;
    });

    cal = selcted.length > 0 ? selcted[0].measurement : "cm";
  }

  return {
    session: state.session,
    initialValues: {
      badgefor: "choose_attendees", // Default selection [Generate badge for]
      printtype: "single",
      calculatein: cal,
      page_size: PAGEDEFAULTSIZE,
      pagewidth: 0,
      pageheight: 0,
      page_padding_top: 0,
      page_padding_left: 0,
      column_spacing: 0,
      row_spacing: 0,
    },
    isGenerateBadgeModalOpen: state.isGenerateBadgeModalOpen, // Generate Badge modal
    userCategoryList: state.userCategoryList, //
    userList: state.dashboardBadgeUserList, //
    allUserList: state.DashboardBadgeAllUserList, // All users list
    badgeList: state.dashboardBadgeList,
    eventDetails: state.userEventDetails,

    // form field values
    printType: selector(state, "printtype"),
    calculationType: selector(state, "calculatein"),
    pageSize: selector(state, "page_size"),
    pageCustomWidth: selector(state, "pagewidth"),
    pageCustomHeight: selector(state, "pageheight"),
    pagePaddingTop: selector(state, "page_padding_top"),
    pagePaddingLeft: selector(state, "page_padding_left"),
    columnSpacing: selector(state, "column_spacing"),
    rowSpacing: selector(state, "row_spacing"),
  };
}

function validate(values) {
  var errors = {};
  var page_size = values["page_size"];
  var pagewidth = values["pagewidth"];
  var pageheight = values["pageheight"];
  var page_padding_top = values["page_padding_top"];
  var page_padding_left = values["page_padding_left"];
  var column_spacing = values["column_spacing"];
  var row_spacing = values["row_spacing"];

  if (page_size === "custom") {
    if (pagewidth === "") {
      errors["pagewidth"] = LocaleStrings.required;
    } else if (
      pagewidth &&
      (!validateDecimalNums(pagewidth) || pagewidth < 0)
    ) {
      errors["pagewidth"] = LocaleStrings.invalid_number;
    }
    if (pageheight === "") {
      errors["pageheight"] = LocaleStrings.required;
    } else if (
      pageheight &&
      (!validateDecimalNums(pageheight) || pageheight < 0)
    ) {
      errors["pageheight"] = LocaleStrings.invalid_number;
    }
  }
  if (
    page_padding_top &&
    (!validateDecimalNums(page_padding_top) || page_padding_top < 0)
  ) {
    errors["page_padding_top"] = LocaleStrings.invalid_number;
  }
  if (
    page_padding_left &&
    (!validateDecimalNums(page_padding_left) || page_padding_left < 0)
  ) {
    errors["page_padding_left"] = LocaleStrings.invalid_number;
  }
  if (
    column_spacing &&
    (!validateDecimalNums(column_spacing) || column_spacing < 0)
  ) {
    errors["column_spacing"] = LocaleStrings.invalid_number;
  }
  if (row_spacing && (!validateDecimalNums(row_spacing) || row_spacing < 0)) {
    errors["row_spacing"] = LocaleStrings.invalid_number;
  }

  return errors;
}

export default connect(mapStateToProps, {
  openGenerateBadgeModal,
  showError,
  showSuccess,
  fetchUsersCategory,
  generateBadges, // Generate pdfs for badges
  blankBadgeUserList,
  sortListUserByCategory, // Fetch users list
  SearchUsersForGenerateBadge,
})(
  reduxForm({
    validate,
    form: "generateBadgeForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(GenerateBadge)
);
